import type { SVGProps } from 'react';
const SvgGavel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#gavel_svg__a)">
      <path d="M8.08 5.242 5.25 8.069l14.134 14.15 2.83-2.827L8.08 5.242ZM12.314.998l-2.828 2.83 5.657 5.655 2.828-2.829L12.314.998ZM3.827 9.486 1 12.315l5.657 5.656 2.828-2.828-5.657-5.657ZM13 21H1v2h12v-2Z" />
    </g>
    <defs>
      <clipPath id="gavel_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGavel;
